/* Internal navigation only. Reporting is handled by the consent-gated Shopify pixel. */
(() => {
  if (window.__hbClickTracking || window.Shopify?.designMode) return;
  // Preview themes must not pollute production click counts.
  if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') return;
  window.__hbClickTracking = true;

  // Shopify exposes this API only after the consent feature has loaded.
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }

  const contentPath = (path) => /^\/(?:$|(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|products|collections|blogs|policies)(?:\/|$))/i.test(path);
  const typeOf = (path) => path.match(/\/(pages|products|collections|blogs|policies)(?:\/|$)/)?.[1] || 'home';

  function track(event) {
    if (!event.isTrusted || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
    const anchor = event.composedPath().find((node) => node instanceof Element && node.matches('a[href]'));
    if (!anchor || anchor.hasAttribute('download')) return;
    const source = new URL(window.location.href);
    let target;
    try { target = new URL(anchor.href, source); } catch (_) { return; }
    if (!/^https?:$/.test(target.protocol) || source.origin !== target.origin) return;
    if (!contentPath(source.pathname) || !contentPath(target.pathname)) return;
    // Same-page controls, fragment links and variant changes are not navigation clicks.
    if (source.pathname === target.pathname) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || !privacy.analyticsProcessingAllowed()) return;
    const publish = window.Shopify?.analytics?.publish;
    if (!publish) return;
    const section = anchor.closest('[id^="shopify-section-"]');
    const area = anchor.closest('#header-group, header') ? 'header'
      : anchor.closest('footer, .shopify-section-group-footer-group') ? 'footer' : 'content';
    // No query strings, fragments, link text, customer data or form values.
    try {
      Promise.resolve(window.Shopify.analytics.publish('hb_navigation_click', {
        source_path: source.pathname,
        target_path: target.pathname,
        target_type: typeOf(target.pathname),
        link_area: area,
        section_id: section?.id || 'none'
      })).catch(() => {});
    } catch (_) { /* Tracking must never interrupt navigation. */ }
  }

  document.addEventListener('click', track, { capture: true });
  document.addEventListener('auxclick', track, { capture: true });
})();
